<template>
  <div>
    <editor-stepper
    />
    <conflicts-viewer />
  </div>
</template>
<script>
import ConflictsViewer from '@/components/conflictResolution/ConflictsViewer'
import EditorStepper from '@/components/editor/EditorStepper'
import helpService from '@/services/help.js'

export default ({
  name: 'ConflictsResolution',

  components: {
    ConflictsViewer,
    EditorStepper
  },

  mixins: [  ],

  created () {
    helpService.setHelpPage(this.$store, 'select_conflict')
  },

})
</script>
<style>

</style>